const React = require("react");
const { PasswordProvider } = require("./src/context/PasswordContext");
const AuthWrapper = require("./src/context/AuthWrapper").default;

exports.wrapRootElement = ({ element }) => (
  <PasswordProvider>{element}</PasswordProvider>
);

exports.wrapPageElement = ({ element }) => (
  <AuthWrapper>{element}</AuthWrapper>
);


exports.onRenderBody = ({ setPostBodyComponents }) => {
  setPostBodyComponents([
    <noscript
      key="gtm-noscript"
      dangerouslySetInnerHTML={{
        __html: `
          <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KHPSNKHZ"
          height="0" width="0" style="display:none;visibility:hidden"></iframe>
        `,
      }}
    />,
  ]);
};
